import { Dialog } from "@headlessui/react";
import { FormBox, ModalFoterBox, ModalHeaderBox } from "../../components/box/Box";
import Button from "../../components/button/Button";
import { Modal, ModalProp } from "../../components/modal/Modal"

export type RequestMethodModalProps = {
  toggle: () => void;
  maxApplicationCount: number;
  maxApplicationSheet: number;
}

export const RequestMethodModal = ({
  open,
  toggle,
  closeOnClickOutside,
  children,
  maxApplicationCount,
  maxApplicationSheet,
}: ModalProp & RequestMethodModalProps) => {

  return (
    <Modal
      open={open}
      toggle={toggle}
      closeOnClickOutside={closeOnClickOutside}
    >
      <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white  text-left shadow-xl transition-all sm:w-full max-w-screen-md ">
        <div className="px-2 pb-4 sm:p-4">
          <div className="text-left mt-3">
            <ModalHeaderBox title={"依頼方法"} />
            <p className="mb-1">1.申請書ダウンロードボタンを押し、申請書のテンプレートをダウンロードしてください。</p>
            <p className="mb-1">2.ダウンロードした申請書に、利用者IDカードを出力したい利用者番号を記載し、申請書添付ボタンを押してください。</p>
            <p className="mb-1">3.申請書のファイルを選択し、アップロードしてください。</p>
            <p className="mb-1">4.アップロード完了後、画面上に申請ボタンが表示されるため申請ボタンを押して申請してください。</p>
            <p className="mb-1">5.申請完了後、メールが届きます。</p>
            <p className="mb-1">6.運営者が申請内容をもとに利用者IDカードを出力します。</p>
            <p className="mb-1">7.出力完了後、一覧に申請書が表示されダウンロード可能となります。</p>
          </div>
          <div style={{ color:"red"}}>
            <p className="mb-1">※月に{maxApplicationCount}回依頼可能です。</p>
            <p className="mb-1">※1回の申請で作成できるカード枚数は{maxApplicationSheet}枚までです。</p>
            <p className="mb-1">※申請した日から利用者IDカードのダウンロード可能になるまで5営業日ほどかかります。</p>
          </div>
        </div>
        <ModalFoterBox>
          <Button
            className="mt-1"
            onClick={toggle}
            children={"閉じる"}
          />
        </ModalFoterBox>
      </Dialog.Panel>
    </Modal>
  )
}